import { Box, Button, Drawer, FormLabel, Grid, Stack, styled, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import FeatherIcon from "feather-icons-react";
import moment from "moment";
import React from "react";
import { CustomTooltip } from "../../consts";
// import Utils from "../../utils";
import CardHeaderTitle from "../card-header-title";
import AppSelect from "../common-form/select-input";
import { useThemeMode } from "../theme";

const Filters = () => {
    const from = moment().startOf("month").toDate();
    const to = moment().endOf("month").toDate();
    const [fromDate, setFromDate] = React.useState(from);
    const [toDate, setToDate] = React.useState(to);
    const [campaigns, setCampaigns] = React.useState([]);
    const [selectedCampaign, setSelectedCampaign] = React.useState("");
    const [agents, setAgents] = React.useState([]);
    const [selectedAgent, setSelectedAgent] = React.useState("");
    const [entities, setEntities] = React.useState([]);
    const [selectedEntity, setSelectedEntity] = React.useState("");
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);
    const { FONT } = useThemeMode();

    const getEntities = async () => {
        // let companies = await Utils.genericList("listCompanies", { limit: 1000 });
        // companies = companies.data.listCompanies.items;
        // setEntities(companies);
    }

    const getCampaigns = async () => {
        // const campaigns = await Utils.genericList("listCampaigns");
        // setCampaigns(campaigns?.data?.listCampaigns?.items || []);
    }

    const getAgents = async () => {
        // const agents = await Utils.genericList("listAgents");
        // setAgents(agents?.data?.listAgents?.items || []);
    }

    React.useEffect(() => {
        const fetchData = async () => {
            getEntities();
            getCampaigns();
            getAgents();
        };
        fetchData();
    }, [])

    const Item = styled("div")({});
    const drawerWidth = 230;

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    const handleApply = () => {
        const formData = {
            from: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            to: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
            entityId: selectedEntity,
            campaignId: selectedCampaign,
            agentId: selectedAgent
        }
        console.log(formData);
    }

    const filterDrawer = (
        <Item>
            <Stack
                direction="row"
                gap={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 2,
                }}
            >
                <CardHeaderTitle
                    title="Filters"
                    tooltip="Apply filters to refine the displayed data"
                />
                <Button variant="text" size="small" sx={{ fontWeight: 500, padding: "0 .5rem", minWidth: 'inherit', marginRight: "-.5rem" }}>Reset All</Button>
            </Stack>
            <Box
                component="form"
                noValidate
                autoComplete="off"
                sx={{ color: "inherit !important" }}
            >
                <FormLabel
                    sx={{
                        fontWeight: 600,
                        fontSize: FONT.SIZE_13,
                        marginBottom: 2,
                        display: "flex",
                    }}
                >
                    Date Range
                </FormLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        sx={{ marginBottom: "1rem" }}
                        label="From"
                        value={fromDate}
                        onChange={(newValue) => {
                            setFromDate(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        slotProps={{
                            textField: {
                                size: "small",
                                sx: {
                                    mb: 2,
                                    width: "100%",
                                    "& .MuiSvgIcon-root": {
                                        fontSize: FONT.SIZE_20,
                                    },
                                },
                            },
                        }}
                    />
                    <DatePicker
                        sx={{ marginBottom: "2rem" }}
                        label="To"
                        minDate={new Date(fromDate)}
                        value={toDate}
                        onChange={(newValue) => {
                            setToDate(newValue);
                        }}
                        onError={() => {
                            setToDate(null);
                        }}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        slotProps={{
                            textField: {
                                size: "small",
                                sx: {
                                    mb: 2,
                                    width: "100%",
                                    "& .MuiSvgIcon-root": {
                                        fontSize: FONT.SIZE_20,
                                    },
                                },
                            },
                        }}
                    />
                </LocalizationProvider>

                <FormLabel
                    sx={{
                        fontWeight: 600,
                        fontSize: FONT.SIZE_13,
                        marginTop: 3,
                        marginBottom: 2,
                        display: "flex",
                    }}
                >
                    Limit To
                </FormLabel>
                <AppSelect
                    name={"entity"}
                    label="Entity"
                    labelKey="name"
                    valueKey="id"
                    options={entities}
                    value={selectedEntity}
                    onChange={(e) => setSelectedEntity(e.target.value)}
                    PlaceHolder={"Select Entity"}
                    sx={{ marginBottom: '1rem' }}
                    size="small"
                />
                <AppSelect
                    name={"campaigns"}
                    label="Campaigns"
                    labelKey="name"
                    valueKey="id"
                    options={campaigns}
                    value={selectedCampaign}
                    onChange={(e) => setSelectedCampaign(e.target.value)}
                    PlaceHolder={"Select Campaign"}
                    sx={{ marginBottom: '1rem' }}
                    size="small"
                />
                <AppSelect
                    name={"agents"}
                    label="Agents"
                    labelKey="name"
                    valueKey="id"
                    options={agents}
                    value={selectedAgent}
                    onChange={(e) => setSelectedAgent(e.target.value)}
                    PlaceHolder={"Select Agent"}
                    sx={{ marginBottom: '1rem' }}
                    size="small"
                />
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleApply}
                    disabled={true} // Disable button until the API is implemented
                >
                    Apply
                </Button>
            </Box>
        </Item>
    );

    return (
        <React.Fragment>
            <CustomTooltip title="Filters" placement="left">
                <Button
                    variant="contained"
                    color="primary"
                    sx={{
                        borderRadius: "4px 0 0 4px",
                        padding: "8px",
                        minWidth: "inherit",
                        position: "fixed",
                        top: 92,
                        right: 0,
                        zIndex: 9,
                        display: { xl: "none" },
                    }}
                    onClick={handleDrawerToggle}
                    aria-label="Filters"
                >
                    <FeatherIcon icon="filter" />
                </Button>
            </CustomTooltip>
            <Drawer
                anchor="right"
                variant="temporary"
                open={mobileOpen}
                onTransitionEnd={handleDrawerTransitionEnd}
                onClose={handleDrawerClose}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    display: { xs: "block", xl: "none" },
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: 260,
                        padding: 2,
                    },
                }}
            >
                {filterDrawer}
            </Drawer>
            <Grid
                item
                xs="auto"
                sx={{
                    display: {
                        xs: "none",
                        xl: "block",
                    },
                    width: { xl: drawerWidth },
                }}
            >
                {filterDrawer}
            </Grid>
        </React.Fragment>
    );
};

export default Filters;
